import React, { FC, MouseEvent } from 'react';
import { isDebug } from '../../../../../../utils/env';
import { useCurrentCategory } from '../../../../../CurrentCategoryProvider';
import { useItemData } from '../../hooks/useItemData';
import { useDragAndDrop } from '../../hooks/useDragAndDrop';
import { useHandleMouseEvents } from '../hooks/useHandleMouseEvents';
import styles from './PresetAreaItem.scss';
import type { PresetAreaItemProps } from './PresetAreaItem.types';

export const PresetAreaItem: FC<PresetAreaItemProps> = ({
  section,
  sectionImageRef,
  item: _item,
  index: itemIndex,
  sectionIndex,
}) => {
  const item = useItemData(_item);

  const { systemId, structure, preset } = item;
  const category = useCurrentCategory();
  const { id: categoryId } = category;

  const { startItemDrag } = useDragAndDrop({ sectionImageRef });

  const { handleClick, handleMouseEnter, handleMouseLeave } = useHandleMouseEvents({
    category,
    item,
    section,
    sectionIndex,
    itemIndex,
  });

  const handleMouseDown = (event: MouseEvent) => {
    startItemDrag(event, {
      categoryId,
      section,
      item,
      itemId: item.id,
      itemStructure: structure,
    });
  };

  const debugProps = isDebug() && {
    'data-system-id': systemId,
  };

  return (
    <area
      data-hook="preset-area-item"
      className={styles.presetAreaItem}
      draggable={false}
      href="#"
      alt=""
      data-comp={structure.componentType}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      shape={preset.shape?.name}
      coords={preset.shape?.coords}
      {...debugProps}
    />
  );
};
